var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',_vm._g(_vm._b({attrs:{"size":_vm.large && !_vm.$attrs.size ? 24 : _vm.$attrs.size || 16}},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(" $"+_vm._s(_vm.name)+"-"+_vm._s(_vm.getSize)+"-"+_vm._s(_vm.getType)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }